module.exports = __webpack_public_path__ + "images/emoji/email.8607e3f99f81ba08489b.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/email.png
// module id = Ugkw
// module chunks = 24